import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="frame">
      <section className="page">
        <div className="page__body">
          <h1 className="page__title">{t('notFound.title')}</h1>
          <p className="page__lede">{t('notFound.lede')}</p>
          <Link className="btn btn--secondary" to="/">
            {t('notFound.home')}
          </Link>
        </div>
      </section>
    </div>
  );
}
